<script>
export const group = 'Bottom'
</script>

<script setup>
import { onMounted, ref } from 'vue'
import useDisappearable from '../../../composables/useDisappearable'
import CharacterEnlarge from './text_animations/CharacterEnlarge.vue'
import CharacterJumpFromTheRight from './text_animations/CharacterJumpFromTheRight.vue'
import TextSlideUp from './text_animations/TextSlideUp.vue'
import { frames } from '../../../utils/frames.js'
const gsapTimeline = useGsapTimeline()

const { item } = defineProps({
  item: Object,
})

const timelineSuperTitle = ref(null)
const timelineTitle = ref(null)
const timelineTitleOut = ref(null)
const timelineSubtitle = ref(null)
const timelineSubtitleOut = ref(null)

const imageElement = ref(null)

onMounted(() => {
  gsapTimeline({ name: 'CurrentProgramSmall' })
    .add(timelineTitle)
    .add(timelineSuperTitle, `<${frames(14)}`)
    .add(timelineSubtitle, `<${frames(2)}`)
    .from(imageElement, { yPercent: 100, duration: frames(15), transformOrigin: 'center center', ease: 'power4.out' }, `<${frames(4)}`)
})

const { onDisappear } = useDisappearable()
onDisappear(async () => {
  timelineSuperTitle.value?.reverse()
  timelineTitle.value?.reverse()

  return await gsapTimeline({ name: 'CurrentProgramSmall - End' })
    .add(timelineTitle)
    .add(timelineSubtitleOut.value(), `<${frames(2)}`)
    .add(timelineSuperTitle, `<${frames(2)}`)
    .to(imageElement, { yPercent: 100, duration: frames(12), ease: 'power4.in' }, `<${frames(4)}`)
})

const image = computed(() => item.enrichment.program.headerImages['visual_radio_transparent_overlay']?.src || item.enrichment.program.headerImages['app_now_header_foreground']?.src)
</script>

<template>
  <div class="absolute bottom-0 z-10 w-full flex justify-between items-end">
    <div class="pl-safe pb-safe flex-1">
      <CharacterEnlarge text="Nu op Q" class="text-white text-[5.5rem] font-bold" @timeline="timelineSuperTitle = $event" />
      <CharacterJumpFromTheRight
        :text="item.enrichment.program.title"
        class="text-q-cr-red-primary mb-1"
        textSizeClass="text-[8rem]"
        textOutlineSizeClass="text-[14.4rem]"
        @timeline="timelineTitle = $event"
        @timelineOut="timelineTitleOut = $event"
      />
      <TextSlideUp :text="item.enrichment.program.humanScheduleCopy" class="text-white text-5xl line-clamp-1" @timeline="timelineSubtitle = $event" @timelineOut="timelineSubtitleOut = $event" />
    </div>
    <div>
      <img v-if="image" ref="imageElement" :src="image" class="object-contain object-right-bottom h-96" />
    </div>
  </div>
</template>
